exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo{margin-bottom:200px}.demo-example{margin-bottom:60px}.demo code{padding:4px;color:#08f;font-weight:700;background-color:#ececec;border-radius:4px}", ""]);

// exports
